import React, { useEffect } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

export interface ILocal {
  coords: [number, number];
  popup: string;
}

interface MapProps {
  locals: ILocal[];
}

const DefaultIcon = L.icon({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
    iconAnchor: [12, 39],
    shadowAnchor: [12, 41],
    popupAnchor: [1, -34]
});

L.Marker.prototype.options.icon = DefaultIcon;

const Map: React.FC<MapProps> = ({ locals }) => {
  useEffect(() => {
    const map = L.map("map").setView([-23.5505, -46.6333], 10); // Centraliza o mapa em São Paulo, Brasil

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(map);

    locals.forEach(({ coords, popup }) => {
      L.marker(coords).addTo(map).bindPopup(popup);
    });

    return () => {
      map.remove();
    };
  }, [locals]); // Dependência para atualizar marcadores quando `locais` mudar

  return <div id="map" style={{ height: "500px", width: "100%" }} />;
};

export default Map;
